export default __webpack_public_path__ + "static/media/PT.72f33d1d.svg";